import * as React from 'react'
import { defineMessages, FormattedHTMLMessage } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileInvoice, faStore, faWatch, faPhoneLaptop } from '@fortawesome/pro-light-svg-icons'
import dashboard from './dashboard.png'
import styles from './about-2.module.scss'

const messages = defineMessages({
  textOneHeading: {
    defaultMessage: 'Du har full koll på ekonomin',
    id: 'consultant.section-three.text-one.heading',
  },
  textOneLede: {
    defaultMessage:
      'Vad skönt det är att Dooer tagit hand om allt. När någon av dina deklarationer ska in är allt redan förberett och klart. Du behöver bara signera med mobilt BankID och skicka in. Och du kan skapa löner enklare än någonsin med en unik överblick i realtid – smart, smidigt och säkert.',
    id: 'consultant.section-three.text-one.lede',
  },
  textTwoHeading: {
    defaultMessage: 'Mjukvaran är precis det du behöver',
    id: 'consultant.section-three.text-three.heading',
  },
  textTwoLede: {
    defaultMessage:
      'Så lättad du blev när du upptäckte att du inte behövde vara ekonom för att driva ditt företag – Dooers mjukvara är ju utvecklad för just dig och dina behov. Du får en notifikation när något dyker upp i din att-göra-lista, du fotar dina utlägg och fakturor som du laddar upp direkt. Allt godkänt med ett klick – klart!',
    id: 'consultant.section-three.text-three.lede',
  },
  featureOneHeading: {
    defaultMessage: 'Säker och trygg bokföring',
    id: 'consultant.section-three.feature-one.heading',
  },
  featureOneLede: {
    defaultMessage: 'Hos oss har du det absolut bästa av två världar. En personlig senior ekonom + intelligent teknik.',
    id: 'consultant.section-three.feature-one.lede',
  },
  featureTwoHeading: {
    defaultMessage: 'Byggt för småföretagare',
    id: 'consultant.section-three.feature-two.heading',
  },
  featureTwoLede: {
    defaultMessage:
      'Dooer är byggt för småföretagare och hos oss får du lika mycket hjälp oavsett hur stort bolag du har.',
    id: 'consultant.section-three.feature-two.lede',
  },
  featureThreeHeading: {
    defaultMessage: 'Mer tid över',
    id: 'consultant.section-three.feature-three.heading',
  },
  featureThreeLede: {
    defaultMessage:
      'Dooer tar hand om din bokföring så du får mer tid att fokusera på det du tycker är roligt – utveckla ditt företag.',
    id: 'consultant.section-three.feature-three.lede',
  },
  featureFourHeading: {
    defaultMessage: 'Supersmidig mjukvara',
    id: 'consultant.section-three.feature-four.heading',
  },
  featureFourLede: {
    defaultMessage:
      'Använd din dator eller mobiltelefon för att då och då utföra små och enkla uppgifter med ett enkelt klick.',
    id: 'consultant.section-three.feature-four.lede',
  },
})

const texts = [
  {
    heading: <FormattedHTMLMessage {...messages.textOneHeading} />,
    lede: <FormattedHTMLMessage {...messages.textOneLede} />,
  },
  {
    heading: <FormattedHTMLMessage {...messages.textTwoHeading} />,
    lede: <FormattedHTMLMessage {...messages.textTwoLede} />,
  },
]

const features = [
  {
    heading: <FormattedHTMLMessage {...messages.featureOneHeading} />,
    lede: <FormattedHTMLMessage {...messages.featureOneLede} />,
    icon: faFileInvoice,
  },
  {
    heading: <FormattedHTMLMessage {...messages.featureTwoHeading} />,
    lede: <FormattedHTMLMessage {...messages.featureTwoLede} />,
    icon: faStore,
  },
  {
    heading: <FormattedHTMLMessage {...messages.featureThreeHeading} />,
    lede: <FormattedHTMLMessage {...messages.featureThreeLede} />,
    icon: faWatch,
  },
  {
    heading: <FormattedHTMLMessage {...messages.featureFourHeading} />,
    lede: <FormattedHTMLMessage {...messages.featureFourLede} />,
    icon: faPhoneLaptop,
  },
]

export default function About2() {
  return (
    <div className={styles.root}>
      <div className={styles.inner}>
        <div className={styles.content}>
          <img alt="dashboard" src={dashboard} />
          <div className={styles.textWrapper}>
            {texts.map((text) => (
              <div className={styles.text} key={text.heading.props.id}>
                <h3>{text.heading}</h3>
                <p>{text.lede}</p>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.features}>
          {features.map((feature, i) => (
            <div className={styles.feature} key={feature.heading.props.id}>
              <i>
                <FontAwesomeIcon icon={feature.icon} />
              </i>
              <h4>{feature.heading}</h4>
              <p>{feature.lede}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
